"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
var angular = require("angular");
var bubble_chart_chart_1 = require("./bubble-chart.chart");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
function formatCell(val, decimalPoint) {
    if (typeof val === 'undefined' || val === null) {
        return '""';
    }
    var str = val.toString().trim();
    if (!isNaN(val)) {
        return str.replace('.', decimalPoint);
    }
    return "\"" + str + "\"";
}
var BubbleChartComponent = /** @class */ (function (_super) {
    __extends(BubbleChartComponent, _super);
    function BubbleChartComponent($scope, $timeout) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'BubbleChart') || this;
        _this.changeLabelLength = function (change) {
            if (change === void 0) { change = 0; }
            var ctrl = _this;
            if (!ctrl.settings.charsInLabel) {
                ctrl.settings.charsInLabel = 0;
            }
            ctrl.settings.charsInLabel = parseInt(ctrl.settings.charsInLabel);
            ctrl.settings.charsInLabel += change;
            ctrl.drawChart();
        };
        var ctrl = _this;
        $scope.$on('command:BUBBLE_CHART', function (event, args) { return ctrl.initComponent(event, args); });
        return _this;
    }
    BubbleChartComponent.prototype.getChartOptions = function (graph, options) {
        return bubble_chart_chart_1.getChartOptions(graph, options);
    };
    BubbleChartComponent.prototype.groupBubbleByRange = function (graph) {
        var _a = JSON.parse(graph.radialDivider), r1 = _a[0], r2 = _a[1];
        var _b = JSON.parse(graph.xscale), r0 = _b[0], r3 = _b[1];
        var p = [r1 * r1, r2 * r2, Number.MAX_VALUE];
        var radialLegends = JSON.parse(graph.radialLegends);
        var range = ["(" + r0 + ", " + r1 + "]", "(" + r1 + ", " + r2 + "]", "(" + r2 + ", " + r3 + "]"];
        var result = radialLegends.map(function (legend, index) {
            return {
                legend: legend,
                range: range[index],
                sum: 0,
                siblingSum: 0
            };
        });
        if (graph.mainRows) {
            graph.mainRows.forEach(function (row) {
                var position = row.originx * row.originx + row.originy * row.originy;
                for (var i = 0; i < p.length; i++) {
                    if (position <= p[i]) {
                        result[i].sum += row.z;
                        break;
                    }
                }
            });
            var mainTotal_1 = result.reduce(function (total, item) { return total + item.sum; }, 0);
            result.forEach(function (item) {
                item.percentage = mainTotal_1 ? 100.0 * item.sum / mainTotal_1 : 0;
            });
        }
        if (graph.siblingRows) {
            graph.siblingRows.forEach(function (row) {
                var position = row.originx * row.originx + row.originy * row.originy;
                for (var i = 0; i < p.length; i++) {
                    if (position <= p[i]) {
                        result[i].siblingSum += row.z;
                        break;
                    }
                }
            });
            var siblingTotal_1 = result.reduce(function (total, item) { return total + item.siblingSum; }, 0);
            result.forEach(function (item) {
                item.siblingPercentage = siblingTotal_1 ? 100.0 * item.siblingSum / siblingTotal_1 : 0;
            });
        }
        return result;
    };
    BubbleChartComponent.prototype.drawChart = function () {
        var ctrl = this;
        var graphData = JSON.parse(JSON.stringify(ctrl.selectedGraph));
        ctrl.rangeGroupedData = ctrl.groupBubbleByRange(graphData);
        ctrl.tableData.inputData = graphData;
        ctrl.tableData = JSON.parse(JSON.stringify(ctrl.tableData));
        var timestamp = ctrl.settings.timestampMode === 'lastRecalc' ? basic_chart_component_1.getDate(ctrl.currentNode.lastRecalc) : basic_chart_component_1.getDate();
        var chartOptions = ctrl.getChartOptions(graphData, {
            currentNode: ctrl.currentNode,
            chartTitle: ctrl.actionMenuItem,
            legends: ctrl.legends,
            settings: ctrl.settings,
            timestamp: timestamp
        });
        basic_chart_component_1.makeChart(chartOptions);
    };
    BubbleChartComponent.prototype.exportCharts = function () {
        var ctrl = this;
        var exporter = new smartorg.r6.lib.ChartExporter("chart", "svg-canvas");
        var title = ctrl.actionMenuItem + " for " + ctrl.currentNode.name;
        exporter.exportChart(title, true);
    };
    BubbleChartComponent.prototype.generateScdCsv = function (csvFormat) {
        if (csvFormat === void 0) { csvFormat = ''; }
        var ctrl = this;
        var cellSeparator = csvFormat === 'EU' ? ';' : ',';
        var decimalPoint = csvFormat === 'EU' ? ',' : '.';
        var headers = [
            '',
            'Range',
            formatCell(ctrl.currentNode.name + " | " + ctrl.selectedGraph.name, decimalPoint),
            'Percentage',
        ];
        var keys = ['legend', 'range', 'sum', 'percentage'];
        if (ctrl.siblingNode) {
            headers.push(formatCell(ctrl.siblingNode.name + " | " + ctrl.selectedGraph.name, decimalPoint));
            headers.push('Percentage');
            keys.push('siblingSum');
            keys.push('siblingPercentage');
        }
        var rows = ctrl.rangeGroupedData;
        var lines = [headers.join(cellSeparator)];
        rows.map(function (row) {
            lines.push(keys.map(function (k) { return formatCell(row[k], decimalPoint); }).join(cellSeparator));
        });
        return lines.join('\n');
    };
    BubbleChartComponent.prototype.exportCsv = function (csvFormat) {
        if (csvFormat === void 0) { csvFormat = ''; }
        var ctrl = this;
        var filename = "BubbleChart_" + ctrl.currentNode.name + "_" + basic_chart_component_1.getDate() + ".csv";
        ctrl.$scope.$broadcast('export:csv', {
            filename: filename, csvFormat: csvFormat, skipSave: true
        }, function (csv) {
            var secondCsv = ctrl.generateScdCsv(csvFormat);
            var blob = new Blob([secondCsv + '\n\n' + csv], { type: "text/plain;charset=utf-8" });
            saveAs(blob, filename);
        });
    };
    BubbleChartComponent = __decorate([
        basic_chart_component_1.Component({
            bindings: {
                menu: '='
            },
            template: require("./bubble-chart.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], BubbleChartComponent);
    return BubbleChartComponent;
}(basic_chart_component_1.BasicChartComponent));
exports.BubbleChartComponent = BubbleChartComponent;
angular.module('smartorg.r6.acts.bubbleChart', []).component('bubbleChart', BubbleChartComponent);
module.exports = 'smartorg.r6.acts.bubbleChart';
//# sourceMappingURL=bubble-chart.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/bubble-chart2/bubble-chart.component.js